import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { getSpecialityData } from '../reduxactions/adminactions/ASpecialityActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API } from '../ApiNames';
import { StepperPanel } from 'primereact/stepperpanel';
import { Stepper } from 'primereact/stepper';
import { fetchAccountDetails, fetchCases } from '../reduxactions/doctoractions/DoctorReportsActions';

export const DoctorReports = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const cases = useSelector((state: RootState) => state.doctorreports.cases);
    const account = useSelector((state: RootState) => state.doctorreports.account);
    console.log(account, 'account')
    const dispatch = useDispatch();
    const stepperRef = useRef(null);



    //To get data
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchCases(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync2 = async () => {
        try {
            await dispatch(fetchAccountDetails(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
        fetchDataAsync1();
        fetchDataAsync2();


    }, [dispatch]);
    const navigate = useNavigate()
    const ViewOpenCase = (rowData: any) => {
        const url = `/casedetails/${rowData.caseid}`;
        console.log('rowdata:', rowData.caseid)
        navigate(url);
    };
    const ViewPrint = (rowData: any) => {
        const url = `/invoice/${rowData.trans_id}`;
        console.log('rowdata:', rowData.caseid)
        navigate(url);
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/doctorreports.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="main-content">
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-9">
                                <h2> Reports List</h2>
                            </div>

                            <div className="col-3">
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2"></div>
                            <div className="box box-primary">
                                <div className="card"></div>
                                <div className="card flex flex-wrap justify-content">
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search" />
                                        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                    </span>
                                </div>
                                <div className="card">
                                    <Stepper ref={stepperRef}>
                                        <StepperPanel header="Cases">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={cases} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['pname', 'cdate', 'Phone', 'Status']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="pname" sortable header="Patient Name" />
                                                            <Column field="cdate" sortable header="Date"></Column>
                                                            <Column header="Status" sortable body={(rowData) => rowData.cstatus ? rowData.cstatus.charAt(0).toUpperCase() + rowData.cstatus.slice(1).toLowerCase() : ''} />
                                                            <Column field="caseid" sortable header="CaseID"></Column>

                                                            <Column header="Operations" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewOpenCase(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>


                                        <StepperPanel header="Account Details">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={account} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['pname', 'amount', 'paid_date', 'trans_id']}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="pname" sortable header="Patient Name" />
                                                            <Column field="amount" sortable header="Amount" />
                                                            <Column field="paid_date" sortable header="Paid Date"></Column>
                                                            <Column field="trans_id" sortable header="Transaction ID"></Column>
                                                            <Column header="Option" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-print" rounded outlined tooltip="Print" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewPrint(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>

                                    </Stepper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </div >
    )
}
